import Vue from 'vue';
import VueCaptcha from '@cnamts/vue-captcha';
import VueCaptchaDesignSystem from '@cnamts/vue-captcha-design-system';

Vue.use(VueCaptcha);
// TODO : remove any
// eslint-disable-next-line
Vue.use(VueCaptchaDesignSystem as any);
